import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";

import React from "react";
import HomeIcon from "@mui/icons-material/Home";
import { Box } from "@mui/system";
import { Button, Container, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import logo from "../assets/img/retail-logo-trans.png";
import { Logout } from "@mui/icons-material";
import { logout, setIsLoggedIn } from "../reducer/action";
import PersonIcon from "@mui/icons-material/Person";

import useGlobalState from "../Context";
import { useLoading } from "./LoadingContext";
import { useNotificationContext } from "./NotificationContext";

const Navbar = ({ toggleSideNavbar }) => {
  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();

  const [, dispatch] = useGlobalState();

  const navigate = useNavigate();
  const onClickRout = (rout) => {
    navigate(rout);
  };
  const logoutMethod = async () => {
    try {
      setLoading(true);

      localStorage.clear();

      dispatch(setIsLoggedIn(false));
      await dispatch(logout());
    } catch (err) {
      showNotification("Error", err?.message ?? "Failed to Logout");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <AppBar
        sx={{
          backgroundColor: "#fff",
          width: `calc(100% - ${240}px)`,
          ml: `${240}px`,
        }}
        position="fixed"
      >
        <Container maxWidth="lg">
          <Toolbar>
            <div
              style={{ cursor: "pointer" }}
              className="logoContainer"
              onClick={() => {
                navigate("/");
              }}
            >
              <img
                src={logo}
                alt="reliance retail"
                title="dock appointment"
                width="90"
                height="45"
              />
              <div className="projectLogo fontSize20">
                <div title="Docker Appointment" className="navBarTitle">
                  Dock Appointment System
                </div>
              </div>
            </div>
            <Box sx={{ flexGrow: 1 }} />
            {/* <Tooltip title="Home">
              <IconButton
                onClick={() => {
                  navigate("/");
                }}
                color="primary"
              >
                <HomeIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Profile">
              <IconButton
                onClick={() => {
                  onClickRout("/view-profile");
                }}
                color="primary"
              >
                <PersonIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Sign Out">
              <IconButton
                onClick={() => {
                  logoutMethod();
                }}
                color="primary"
              >
                <Logout />
              </IconButton>
            </Tooltip> */}
            <Tooltip title="Home">
              <Button
                sx={{ mx: 1 }}
                onClick={() => {
                  navigate("/");
                }}
                color="primary"
                startIcon={<HomeIcon />}
              >
                Home
              </Button>
            </Tooltip>
            <Tooltip title="Profile">
              <Button
                sx={{ mx: 1 }}
                onClick={() => {
                  onClickRout("/view-profile");
                }}
                color="primary"
                startIcon={<PersonIcon />}
              >
                Profile
              </Button>
            </Tooltip>
            <Tooltip title="Sign Out">
              <Button
                variant="outlined"
                sx={{ ml: 1 }}
                startIcon={<Logout color="error" />}
                onClick={() => {
                  logoutMethod();
                }}
                color="primary"
              >
                Logout
              </Button>
            </Tooltip>
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  );
};

export default Navbar;
